import * as BABYLON from '@babylonjs/core/Legacy/legacy';


import { config } from '../config.js'
import { GameScene } from '../scene.js';
import { IMeshPool } from './common.js'


const segmentSize = config.pathSegmentSize
const log = console.log.bind(console)



export class CollideEndBoxPool implements IMeshPool {
    meshes: BABYLON.Mesh[]
    scene: GameScene
    static height = 0.5

    constructor(scene: GameScene) {
        this.meshes = []
        this.scene = scene
        this.createMeshes()
    }

    createMeshes() {
        let floorSize = segmentSize

        let bbScene = this.scene.bbScene
        var mat = new BABYLON.StandardMaterial("collide_end", bbScene)
        mat.diffuseColor = new BABYLON.Color3(0.5, 0, 0)
        mat.alpha = 0.0


        for (let i = 0; i < config.collideEndBoxPreloadNum; i++) {
            // 碰撞用的 box
            let box1 = BABYLON.MeshBuilder.CreateBox('collide_box', {})
            box1.scaling.x = floorSize
            box1.scaling.z = 0.2
            box1.scaling.y = CollideEndBoxPool.height
            box1.material = mat
            this.meshes.push(box1)
        }
    }

    getMesh(): BABYLON.Mesh {
        let res = this.meshes.pop()
        res.position.y = config.groundHeight + CollideEndBoxPool.height / 2
        return res
    }

    returnMesh(mesh: BABYLON.Mesh) {
        mesh.position.y = -10
        mesh.rotation.x = mesh.rotation.y = mesh.rotation.z = 0
        this.meshes.push(mesh)
    }
}